export var SDKEnvironment = {};
export function createSDK(SDKBaseCtor, environment) {
    Object.assign(SDKEnvironment, environment);
    return SDKBaseCtor;
}
export var envNameToNpmName = {
    'magic-sdk': 'magic-sdk',
    'magic-sdk-rn': '@magic-sdk/react-native',
};
//# sourceMappingURL=sdk-environment.js.map